<template>
  <div class="app-container app-theme-white page-layout">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {},
  data() {
    return {};
  },
  methods: {}
};
</script>
